import { Field } from 'formik';
import type { FieldProps } from 'formik';

import {
  TeamMemberSelect,
  UNASSIGNED_OPTION,
} from 'modules/common/smartComponents/TeamMemberSelect';

import type { FormData } from '../types';
import { HorizontalFormControl } from './HorizontalFormControl';

export const EstimatorFilter = () => {
  return (
    <HorizontalFormControl label="Estimator">
      <Field name="estimatorIn">
        {({ field, form }: FieldProps<FormData['estimatorIn'], FormData>) => (
          <TeamMemberSelect
            isMulti
            mode="assignmentFilter"
            onChange={(selectedEstimators) => {
              if (selectedEstimators.includes(UNASSIGNED_OPTION)) {
                form.setFieldValue(field.name, []);
                form.setFieldValue('estimatorIsUnassigned', true);
              } else {
                form.setFieldValue(
                  field.name,
                  selectedEstimators?.map(({ value }) => value),
                );
                form.setFieldValue('estimatorIsUnassigned', false);
              }
            }}
            value={
              form.values.estimatorIsUnassigned
                ? [UNASSIGNED_OPTION]
                : field.value
            }
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
